export const genUTM = (productUrl, productName) => {
	if(!productUrl || productUrl === null || productUrl === undefined) return ''; // return empty string
	if(productUrl) return `${productUrl}${productUrl.indexOf('?') > 0 ? '&' : '?'}utm_source=preferabli&utm_medium=productrec&utm_campaign=similar%20tasting%20products${(productName && productName.length) && `&utm_content=${productName.replace(/\s+/g, '-').toLowerCase()}`}`;
}

export const createUTMTag = (params) => {
  const {
    url,
    ...utmKeys
  } = params;
  if(!url || url === null || url === undefined) return '';
  return `${url}${url.indexOf('?') > 0 ? '&' : '?'}${Object.keys(utmKeys).map((key) => `utm_${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&')}`;
}

export const formattedRelativePath = (string) => {
  const relative_path = string.toLowerCase().trim();
  return !relative_path.startsWith('/') ? `/${relative_path}` : relative_path;
};

export const fetchParams = (string = null) => {
  const searchParamsString = string || window.location.search;
  if (searchParamsString.length) {
    const params = new URLSearchParams(searchParamsString);

    const obj = {};

    for (const key of params.keys()) {
      if (key.includes('[]') && params.getAll(key).length >= 1) {
        obj[key.replace('[]', '')] = Array.from(params.getAll(key));
      } else if(!key.includes('[]') && params.getAll(key).length >= 1){
        obj[key] = Array.from(params.getAll(key));
      } else {
        const value = params.get(key);
        if (value.match(/(\[)[^*]+(\])/)) {
          const cleanedVal = value.replace(/[\[\]']+/g, '').split(',');
          obj[key] = cleanedVal;
        } else {
          obj[key] = params.get(key);
        }
      }
    }
    return obj;
  }
  return {};
};

export const serializeParams = (params) => Object.keys(params)
  .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
  .join('&');

export const getParamsFromUrl = (paramList) => {
    const urlParams = new URLSearchParams(window.location.search);
    return paramList.find(param => urlParams.has(param)) 
        ? { key: paramList.find(param => urlParams.has(param)), value: urlParams.get(paramList.find(param => urlParams.has(param))) } 
        : null;
}